<div class="main-container" (click)="onClickCell()">
    <span>{{params.valueFormatted ? params.valueFormatted : params.value}} </span>
</div>